import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LoaderComponent } from '@bo-client/shared/loader/loader.component';
import { LoadingOverlayComponent } from '@bo-client/shared/loading-overlay/loading-overlay.component';
// tslint:disable-next-line:max-line-length
import { FlexModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ArchiveDocumentModalComponent } from '@bo-client/core/activities/archive-document-modal/archive-document-modal.component';
import { CodeListValuesListComponent } from '@bo-client/shared/code-list-values/code-list-values-list/code-list-values-list.component';
import { CodeListValuesComponent } from '@bo-client/shared/code-list-values/code-list-values.component';
import { ShowListValuesComponent } from '@bo-client/shared/code-list-values/show-list-values/show-list-values.component';
import { ActivityDetailComponent } from '@bo-client/shared/components/activity-detail/activity-detail.component';
import { ConfirmAndCreateActivityComponent } from '@bo-client/shared/components/confirm-and-create-activity/confirm-and-create-activity.component';
import { CustomButtonComponent } from '@bo-client/shared/components/custom-button/custom-button.component';
import { DisplayAndSelectOptionComponent } from '@bo-client/shared/components/display-and-selec-option/display-and-select-option.component';
import { SelectOptionModalComponent } from '@bo-client/shared/components/display-and-selec-option/select-option-modal/select-option-modal.component';
import { DocumentsListComponent } from '@bo-client/shared/components/documents-list/documents-list.component';
import { EditContactDataComponent } from '@bo-client/shared/components/edit-contact-data/edit-contact-data.component';
import { ErrorPageComponent } from '@bo-client/shared/components/error-page/error-page.component';
import { FormConfirmationComponent } from '@bo-client/shared/components/form-confirmation/form-confirmation.component';
import { GetGisDataComponent } from '@bo-client/shared/components/get-gis-data/get-gis-data.component';
import { GetIbanComponent } from '@bo-client/shared/components/get-iban/get-iban.component';
import { GpSelectComponent } from '@bo-client/shared/components/gp-select/gp-select.component';
import { PrivacyPolicyComponent } from '@bo-client/shared/components/privacy-policy/privacy-policy.component';
import { ShowActivitiesComponent } from '@bo-client/shared/components/show-activities/show-activities.component';
import { StatusLabelComponent } from '@bo-client/shared/components/status-label/status-label.component';
import { TermsConditionsComponent } from '@bo-client/shared/components/terms-conditions/terms-conditions.component';
import { ThankYouComponent } from '@bo-client/shared/components/thank-you/thank-you.component';
import { TooltipIconComponent } from '@bo-client/shared/components/tooltip-icon/tooltip-icon.component';
import { UploadDocumentsComponent } from '@bo-client/shared/components/upload-documents/upload-documents.component';
import { UserSelectComponent } from '@bo-client/shared/components/user-select/user-select.component';
import { DuplicateCheckCoreDebitorComponent } from '@bo-client/shared/components/duplicate-check-core-debitor/duplicate-check-core-debitor.component';
import { DuplicateCheckModalComponent } from '@bo-client/shared/components/duplicate-check-core-debitor/duplicate-check-modal.component';
import { CreateErpBusinessPartnerModalComponent } from '@bo-client/shared/components/duplicate-check-core-debitor/create-erp-business-partner-modal.component';
import { ContentSlideOverComponent } from '@bo-client/shared/content-slide-over/content-slide-over.component';
import { FormFocusableDirective } from '@bo-client/shared/directives/focusable-directive';
import { HideCustomFieldsDirective } from '@bo-client/shared/directives/hide-custom-fields.directive';
import { DocumentsComponent } from '@bo-client/shared/documents/documents.component';
import { ColumnEditorPageableComponent } from '@bo-client/shared/dynamic-search-serverside/column-editor-pageable/column-editor-pageable.component';
import { ListService } from '@bo-client/shared/dynamic-search-serverside/list-service';
import { FileUploadComponent } from '@bo-client/shared/file-upload/file-upload.component';
import { ShowErrorsComponent } from '@bo-client/shared/form-errors/show-errors/show-errors.component';
import { DataRangeComponent } from '@bo-client/shared/forms/data-range/data-range.component';
import { DefaultCardComponent } from '@bo-client/shared/forms/default-card/default-card.component';
import { HeaderTitleComponent } from '@bo-client/shared/forms/header-title/header-title.component';
import { ImageUploadComponent } from '@bo-client/shared/image-upload/image-upload.component';
import { GenericConfirmationModalComponent } from '@bo-client/shared/modals/generic-confirmation-modal/generic-confirmation-modal.component';
import { GenericSingleInputModalComponent } from '@bo-client/shared/modals/generic-single-input-modal/generic-single-input-modal.component';
import { GenericTwoOptionsModalComponent } from '@bo-client/shared/modals/generic-two-options-modal/generic-two-options-modal.component';
import { SendMessageModalComponent } from '@bo-client/shared/modals/send-message-modal/send-message-modal.component';
import { UploadDocumentModalComponent } from '@bo-client/shared/modals/upload-document-modal/upload-document-modal.component';
import { ActionToExecuteType } from '@bo-client/shared/pipes/action-to-execute-type.pipe';
import {
  ActivityDescriptionPipe,
  ActivityIconPipe,
  ActivityInformationPipe,
  ActivityTypePipe,
  LastActivityStatePipe,
  StatusEntityAuditActivityPipe,
  UserActivityPipe
} from '@bo-client/shared/pipes/activity-type.pipe';
import { AreaIconPipe } from '@bo-client/shared/pipes/area-icon.pipe';
import { AreaTextPipe, AreaTypePipe } from '@bo-client/shared/pipes/area-text.pipe';
import { BooleanReadablePipe } from '@bo-client/shared/pipes/boolean-readable.pipe';
import { SupplyAppointmentPartDayPipe } from '@bo-client/shared/pipes/commissioning.pipe';
import { ContactNamePipe } from '@bo-client/shared/pipes/contact-name.pipe';
import { ConversationStatePipe } from '@bo-client/shared/pipes/conversation-state.pipe';
import { DocumentTypePipe } from '@bo-client/shared/pipes/document-type.pipe';
import { EtrsToWsgPipe } from '@bo-client/shared/pipes/etrs-to-wsg.pipe';
import { FilterValidPassPipe } from '@bo-client/shared/pipes/filter-installer-pass.pipe';
import { ChronoUnitPipe } from '@bo-client/shared/pipes/generic-pipes/chrono-unit.pipe';
import {
  CheckBooleanFieldsPipe,
  CompareFieldValuePipe,
  OrderByDatePipe
} from '@bo-client/shared/pipes/generic-pipes/filter-pipes';
import { SafeHtmlPipe } from '@bo-client/shared/pipes/generic-pipes/safe-html.pipe';
import { SafeUrlPipe } from '@bo-client/shared/pipes/generic-pipes/safe-url.pipe';
import { GermanCurrencyPipe } from '@bo-client/shared/pipes/german-currency.pipe';
import { GisObjectLinksPipe } from '@bo-client/shared/pipes/gis-object-link.pipe';
import { GpNamePipe } from '@bo-client/shared/pipes/gp-name.pipe';
import {
  ShowHeaderTmDocumentPipe,
  TextHeaderTmDocumentPipe
} from '@bo-client/shared/pipes/header-tm-document.pipe';
import { OfferStatePipe } from '@bo-client/shared/pipes/offer-state.pipe';
import { OpenActivitiesPipe } from '@bo-client/shared/pipes/open-activities.pipe';
import { OrderStatePipe } from '@bo-client/shared/pipes/order-state.pipe';
import { PassTypePipe } from '@bo-client/shared/pipes/pass-type.pipe';
import { QuestionTypePipe } from '@bo-client/shared/pipes/question-type.pipe';
import { HasRole } from '@bo-client/shared/pipes/roles.pipe';
import { SapCSOrderLinkPipe } from '@bo-client/shared/pipes/sap-cs-order-link-pipe';
import {
  FilterExpirePassPipe,
  PassExpiredPipe,
  PassStatusDisplayPipe,
  RequestStatusPipe,
  StatusDisplayNamePipe,
  StatusPassCssPipe,
  StatusProgressPipe
} from '@bo-client/shared/pipes/status-progress.pipe';
import { TiefbauPipe } from '@bo-client/shared/pipes/tiefbau.pipe';
import {
  UiAdaptionValuePipe,
  UiAdaptionVisiblePipe,
  UiAdaptionVisibleAsyncPipe,
  UiCheckIfValuesPipe
} from '@bo-client/shared/pipes/ui-adaption-value-pipe';
import { UiShowCustomFieldsPipe } from '@bo-client/shared/pipes/ui-show-custom-fields.pipe';
import { ProgressBarComponent } from '@bo-client/shared/progress-bar/progress-bar.component';
import { SheetUploadComponent } from '@bo-client/shared/sheet-upload/sheet-upload.component';
import { DisplayConceptComponent } from '@bo-client/shared/summaries/display-concept/display-concept.component';
import { ValueWithLabelComponent } from '@bo-client/shared/summaries/value-with-label/value-with-label.component';
import { ToolTipDirective } from '@bo-client/shared/tooltip/tooltip.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FileUploadModule } from 'ng2-file-upload';
import { FormRowComponent } from './components/layout/form-row/form-row.component';
import { ScrollSpyMenuComponent } from './components/scroll-spy-menu/scroll-spy-menu.component';

import { MatBadgeModule } from '@angular/material/badge';
import { RouterLink } from '@angular/router';
import {
  ActionTypePipe,
  HasInvalidExistingDevicesPipe,
  PowerMeterTypeDisplayNamePipe
} from '@bo-client/activation-management/shared/pipes/commissioning-pipes';
import { AppMaterialModule } from '@bo-client/app.material.module';
import { CreateErpOrderComponent } from '@bo-client/shared/components/create-erp-order/create-erp-order.component';
import { CustomNotificationComponent } from '@bo-client/shared/components/custom-notification/custom-notification.component';
import { DragDropTodoListComponent } from '@bo-client/shared/components/drag-drop-todo-list/drag-drop-todo-list.component';
import { FieldSelectMultipleComponent } from '@bo-client/shared/components/field-select-multiple/field-select-multiple.component';
import { ManageDocumentListComponent } from '@bo-client/shared/components/manage-document-list/manage-document-list.component';
import { ShowCreateUpdateDataComponent } from '@bo-client/shared/components/show-header-data/show-create-update-data/show-create-update-data.component';
import { ShowHeaderDataComponent } from '@bo-client/shared/components/show-header-data/show-header-data.component';
import { ShowLastActivityComponent } from '@bo-client/shared/components/show-last-activity/show-last-activity.component';
import { ShowNextActionInfoComponent } from '@bo-client/shared/components/show-next-action-info/show-next-action-info.component';
import {
  exclusiveMaximumValidationMessage,
  exclusiveMinimumValidationMessage,
  maxItemsValidationMessage,
  maxlengthValidationMessage,
  maxValidationMessage,
  minItemsValidationMessage,
  minlengthValidationMessage,
  minValidationMessage,
  multipleOfValidationMessage
} from '@bo-client/shared/configuration/formly-extensions/enum-display-name.extension';
import { ArrayTypeComponent } from '@bo-client/shared/configuration/formly-types/array.type';
import { CodeTypeComponent } from '@bo-client/shared/configuration/formly-types/code.type';
import { HtmlWithPreviewTypeComponent } from '@bo-client/shared/configuration/formly-types/htmlWithPreview.type';
import { MultiSchemaTypeComponent } from '@bo-client/shared/configuration/formly-types/multi-schema.type';
import { NullTypeComponent } from '@bo-client/shared/configuration/formly-types/null.type';
import { ObjectTypeComponent } from '@bo-client/shared/configuration/formly-types/object.type';
import { GenericProcessConfigurationComponent } from '@bo-client/shared/configuration/generic-process-configuration/generic-process-configuration.component';
import { ConfigAuditHistoryComponent } from '@bo-client/shared/configuration/config-audit-history/config-audit-history.component';
import { ConfigChangesDialogComponent } from '@bo-client/shared/configuration/config-changes-dialog/config-changes-dialog.component';
import { CustomFormDirective } from '@bo-client/shared/directives/custom-form-directive';
import { FocusEndOfInputDirective } from '@bo-client/shared/directives/focus-end-of-input.directive';
import { ErrorComponent } from '@bo-client/shared/error/error.component';
import { ChangePasswordComponent } from '@bo-client/shared/login/change-password/change-password.component';
import { EditPersonalDataModalComponent } from '@bo-client/shared/login/edit-personal-data-modal/edit-personal-data-modal.component';
import { LoginDialogComponent } from '@bo-client/shared/login/login-dialog/login-dialog.component';
import { MailConfirmationComponent } from '@bo-client/shared/login/mail-confirmation/mail-confirmation.component';
import { EditDocumentModalComponent } from '@bo-client/shared/modals/edit-document-modal/edit-document-modal.component';
import { GenericThreeOptionsModalComponent } from '@bo-client/shared/modals/generic-three-options-modal/generic-three-options-modal.component';
import { RequestApprovalModalComponent } from '@bo-client/shared/modals/request-approval-modal/request-approval-modal.component';
import { CodeListValuePipe } from '@bo-client/shared/pipes/code-list-value.pipe';
import { EntityListPageColumnDefinitionsPipe } from '@bo-client/shared/pipes/entity-list-page-column-definitions.pipe';
import { FelixProjectLinkPipe } from '@bo-client/shared/pipes/felix-project-link-pipe';
import { JaNeinPipe } from '@bo-client/shared/pipes/generic-pipes/boolean.pipe';
import { IsControlRequiredPipe } from '@bo-client/shared/pipes/generic-pipes/is-control-required.pipe';
import { RemoveHtmlTagsPipe } from '@bo-client/shared/pipes/generic-pipes/remove-html-tags.pipe';
import { LinkedCommissioningPipe } from '@bo-client/shared/pipes/linked-commissioning.pipe';
import { RobustDatePipe } from '@bo-client/shared/pipes/robust-date.pipe';
import { TenantlessEmailPipe } from '@bo-client/shared/pipes/tenantless-email.pipe';
import { VeniosSimulationDeeplinkPipe } from '@bo-client/shared/pipes/venios-simulation-deeplink-pipe';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { AgGridModule } from 'ag-grid-angular';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { QuillModule } from 'ngx-quill';
import { GenerateDocumentModalComponent } from '../shared/generate-document-modal/generate-document-modal.component';
import { CommissioningRequestsPreviewComponent } from './components/commissioning-requests-preview/commissioning-requests-preview.component';
import { ConnectionObjectAddressComponent } from './components/connection-object/connection-object-address/connection-object-address.component';
import { ConnectionObjectComponent } from './components/connection-object/connection-object.component';
import { ExtendedListFilterComponent } from './components/extended-list-filter/extended-list-filter.component';
import { FilterInfoModalComponent } from './components/extended-list-filter/filter-info-modal/filter-info-modal.component';
import { HintCardComponent } from './components/hint-card/hint-card.component';
import { OrderRequestsPreviewComponent } from './components/order-requests-preview/order-requests-preview.component';
import { EditActionModalComponent } from './configuration/next-actions/edit-action-modal/edit-action-modal.component';
import { ManageNextActionsComponent } from './configuration/next-actions/manage-next-actions.component';
import { MeasureDirective } from './directives/measure.directive';
import { DynamicActionButtonRowComponent } from './dynamic-action-button-row/dynamic-action-button-row.component';
import { ActionsCellRendererComponent } from './entity-list-page/cell-renderers/actions-cell-renderer/actions-cell-renderer.component';
import { IconCellRendererComponent } from './entity-list-page/cell-renderers/icon-cell-renderer/icon-cell-renderer.component';
import { ListCellRendererComponent } from './entity-list-page/cell-renderers/list-cell-renderer/list-cell-renderer.component';
import { NextActionCellRendererComponent } from './entity-list-page/cell-renderers/next-action-cell-renderer/next-action-cell-renderer.component';
import { EntityListPageComponent } from './entity-list-page/entity-list-page.component';
import { ErpOrderListComponent } from './erp-integration/erp-order-list/erp-order-list.component';
import { ContactAddressFormpartComponent } from './forms/contact-form/contact-address-formpart/contact-address-formpart.component';
import { ContactDetailsFormpartComponent } from './forms/contact-form/contact-details-formpart/contact-details-formpart.component';
import { ContactFormComponent } from './forms/contact-form/contact-form.component';
import { MeterOperatorDataComponent } from './forms/meter-operator-data/meter-operator-data.component';
import { DisplayNamePipe } from './pipes/displayName.pipe';
import { RequestEntityDetailPageComponent } from './request-entity-detail-page/request-entity-detail-page.component';
import { SapConnectionObjectSelectorComponent } from './components/sap-connection-object-selector/sap-connection-object-selector.component';
import { GenericSelectionModalComponent } from './modals/generic-selection-modal/generic-selection-modal.component';
import { CommissioningRequestListV2Service } from '@bo-client/activation-management/commissioning/commissioning-request-list-v2/commissioning-request-list-v2.service';
import { GridRegistrationService } from '@bo-client/activation-management/grid-registration/grid-registration.service';
import { ExternalPrivacyFormFieldComponent } from '@bo-client/shared/components/external-privacy-form-field/external-privacy-form-field.component';
import { ShowActivitiesProxyComponent } from '@bo-client/shared/components/show-activities/show-activities-proxy/show-activities-proxy.component';
import { CalculationDetailComponent } from '../nap/shared/calculation-detail/calculation-detail.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { QuillFormInputComponent } from '@bo-client/shared/components/quill-form-input/quill-form-input.component';
import { AdaptionSuppressAutocompleteDirective } from '@bo-client/shared/directives/adaption-suppress-autocomplete.directive';
import { PanelWrapperComponent } from './components/layout/panel-wrapper/panel-wrapper.component';
import { IsPersonPipe, SalutationTitlePipe } from '@bo-client/shared/pipes/salutation.pipe';
import { ShowCreateUpdateConnectionObjectContactDataComponent } from '@bo-client/shared/components/show-header-data/show-create-update-data/show-create-update-connection-object-contact-data/show-create-update-connection-object-contact-data.component';
import { UserDecisionRadioButtonsComponent } from '@bo-client/shared/forms/formparts/user-decision-radio-buttons/user-decision-radio-buttons.component';
import { TenantConfigProxyComponent } from './components/tenant-config-proxy/tenant-config-proxy.component';
import { TenantConfigPipe } from '@bo-client/shared/pipes/tenant-config.pipe';
import { FeedbackCardComponent } from './components/feedback-card/feedback-card.component';
import { TicketCellRendererComponent } from './entity-list-page/cell-renderers/ticket-cell-renderer/ticket-cell-renderer.component';
import { TicketSystemProxyComponent } from '@bo-client/shared/components/ticket-system/ticket-system-proxy/ticket-system-proxy.component';
import { ZendeskTicketDetails } from '@bo-client/shared/components/ticket-system/zendesk-ticket-details/zendesk-ticket-details.component';
import { ZendeskTicketChat } from '@bo-client/shared/components/ticket-system/zendesk-ticket-details/zendesk-ticket-chat/zendesk-ticket-chat.component';
import { BusinessPartnerFormpartComponent } from './components/business-partner-formpart/business-partner-formpart.component';
import { ComparisonTableComponent } from '@bo-client/shared/components/comparison-table/comparison-table.component';
import { EditPersonalizationModalComponent } from '@bo-client/shared/login/edit-personalization-modal/edit-personalization-modal.component';
import { StringCheckboxComponent } from '@bo-client/shared/forms/formparts/string-checkbox.component';
import { EntityListPageExportPipe } from '@bo-client/shared/pipes/entity-list-page-export.pipe';
import { EntityListInfoModalComponent } from '@bo-client/shared/entity-list-page/entity-list-info-modal/entity-list-info-modal.component';
import { CustomFilterMenuComponent } from '@bo-client/shared/entity-list-page/custom-filter/custom-filter-menu/custom-filter-menu.component';
import { CustomFilterModalComponent } from '@bo-client/shared/entity-list-page/custom-filter/custom-filter-modal/custom-filter-modal.component';
import { EntityDetailLayoutV2Component } from './entity-detail-layout-v2/entity-detail-layout-v2.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FileUploadModule,
    NgSelectModule,
    FlexModule,
    AngularSvgIconModule,
    AppMaterialModule,
    AgGridModule,
    FormlyModule.forRoot({
      extras: { resetFieldOnHide: true },
      validationMessages: [
        { name: 'required', message: 'This field is required' },
        { name: 'null', message: 'should be null' },
        { name: 'minlength', message: minlengthValidationMessage },
        { name: 'maxlength', message: maxlengthValidationMessage },
        { name: 'min', message: minValidationMessage },
        { name: 'max', message: maxValidationMessage },
        { name: 'multipleOf', message: multipleOfValidationMessage },
        {
          name: 'exclusiveMinimum',
          message: exclusiveMinimumValidationMessage
        },
        {
          name: 'exclusiveMaximum',
          message: exclusiveMaximumValidationMessage
        },
        { name: 'minItems', message: minItemsValidationMessage },
        { name: 'maxItems', message: maxItemsValidationMessage },
        { name: 'uniqueItems', message: 'should NOT have duplicate items' }
      ],
      types: [
        { name: 'string', extends: 'input' },
        { name: 'code', component: CodeTypeComponent },
        { name: 'htmlWithPreview', component: HtmlWithPreviewTypeComponent },
        {
          name: 'number',
          extends: 'input',
          defaultOptions: {
            templateOptions: {
              type: 'number'
            }
          }
        },
        {
          name: 'integer',
          extends: 'input',
          defaultOptions: {
            templateOptions: {
              type: 'number'
            }
          }
        },
        { name: 'boolean', extends: 'checkbox' },
        { name: 'enum', extends: 'select' },
        {
          name: 'null',
          component: NullTypeComponent,
          wrappers: ['form-field']
        },
        { name: 'array', component: ArrayTypeComponent },
        { name: 'object', component: ObjectTypeComponent, wrappers: ['panel'] },
        { name: 'multischema', component: MultiSchemaTypeComponent }
      ],
      wrappers: [{ name: 'panel', component: PanelWrapperComponent }]
    }),
    FormlyMaterialModule,
    QuillModule.forRoot(),
    RouterLink,
    MonacoEditorModule,
    MatBadgeModule,
    DragDropModule
  ],
  declarations: [
    ActionsCellRendererComponent,
    LoadingOverlayComponent,
    LoaderComponent,
    GenericConfirmationModalComponent,
    GenericTwoOptionsModalComponent,
    GenericSingleInputModalComponent,
    GenericThreeOptionsModalComponent,
    UploadDocumentModalComponent,
    SendMessageModalComponent,
    ContentSlideOverComponent,
    AreaIconPipe,
    AreaTextPipe,
    AreaTypePipe,
    HasRole,
    GpNamePipe,
    ActivityTypePipe,
    OfferStatePipe,
    OrderStatePipe,
    DocumentTypePipe,
    GermanCurrencyPipe,
    BooleanReadablePipe,
    TiefbauPipe,
    GisObjectLinksPipe,
    EtrsToWsgPipe,
    OpenActivitiesPipe,
    ConversationStatePipe,
    FileUploadComponent,
    EditContactDataComponent,
    GpSelectComponent,
    UserSelectComponent,
    ArchiveDocumentModalComponent,
    DocumentsComponent,
    UiShowCustomFieldsPipe,
    LinkedCommissioningPipe,
    LastActivityStatePipe,
    ContactNamePipe,
    CheckBooleanFieldsPipe,
    CompareFieldValuePipe,
    OrderByDatePipe,
    ProgressBarComponent,
    StatusProgressPipe,
    StatusPassCssPipe,
    PassStatusDisplayPipe,
    PassExpiredPipe,
    FilterExpirePassPipe,
    VeniosSimulationDeeplinkPipe,
    ShowHeaderTmDocumentPipe,
    TextHeaderTmDocumentPipe,
    FilterValidPassPipe,
    HideCustomFieldsDirective,
    ColumnEditorPageableComponent,
    LastActivityStatePipe,
    ContactNamePipe,
    SapCSOrderLinkPipe,
    FelixProjectLinkPipe,
    UiAdaptionValuePipe,
    UiAdaptionVisiblePipe,
    UiAdaptionVisibleAsyncPipe,
    UiCheckIfValuesPipe,
    PassTypePipe,
    ActivityDetailComponent,
    ToolTipDirective,
    GetGisDataComponent,
    ConfirmAndCreateActivityComponent,
    DocumentsListComponent,
    FormFocusableDirective,
    FocusEndOfInputDirective,
    CustomFormDirective,
    ShowErrorsComponent,
    ActionToExecuteType,
    SupplyAppointmentPartDayPipe,
    SheetUploadComponent,
    SafeHtmlPipe,
    RemoveHtmlTagsPipe,
    ImageUploadComponent,
    TermsConditionsComponent,
    PrivacyPolicyComponent,
    HeaderTitleComponent,
    DefaultCardComponent,
    QuestionTypePipe,
    DisplayAndSelectOptionComponent,
    SelectOptionModalComponent,
    FormRowComponent,
    CustomButtonComponent,
    UploadDocumentsComponent,
    ChronoUnitPipe,
    CodeListValuesComponent,
    CodeListValuesListComponent,
    ShowListValuesComponent,
    ScrollSpyMenuComponent,
    DataRangeComponent,
    RequestStatusPipe,
    StatusDisplayNamePipe,
    DisplayNamePipe,
    GetIbanComponent,
    ValueWithLabelComponent,
    DisplayConceptComponent,
    ActivityIconPipe,
    ActivityDescriptionPipe,
    ActivityInformationPipe,
    UserActivityPipe,
    StatusEntityAuditActivityPipe,
    ThankYouComponent,
    FormConfirmationComponent,
    ShowActivitiesComponent,
    TooltipIconComponent,
    StatusLabelComponent,
    DuplicateCheckCoreDebitorComponent,
    DuplicateCheckModalComponent,
    CreateErpBusinessPartnerModalComponent,
    RobustDatePipe,
    ErrorPageComponent,
    JaNeinPipe,
    EntityListPageColumnDefinitionsPipe,
    EntityListPageExportPipe,
    RequestApprovalModalComponent,
    FieldSelectMultipleComponent,
    DragDropTodoListComponent,
    CustomNotificationComponent,
    MailConfirmationComponent,
    ChangePasswordComponent,
    LoginDialogComponent,
    EditPersonalDataModalComponent,
    ShowLastActivityComponent,
    ShowHeaderDataComponent,
    ShowCreateUpdateDataComponent,
    ShowCreateUpdateConnectionObjectContactDataComponent,
    DocumentsListComponent,
    ManageDocumentListComponent,
    EditDocumentModalComponent,
    RequestEntityDetailPageComponent,
    DynamicActionButtonRowComponent,
    MeasureDirective,
    EntityListPageComponent,
    CustomFilterMenuComponent,
    CustomFilterModalComponent,
    ListCellRendererComponent,
    ActionsCellRendererComponent,
    GenerateDocumentModalComponent,
    TenantlessEmailPipe,
    CodeListValuePipe,
    IsControlRequiredPipe,
    SafeUrlPipe,

    // Formly custom Types
    ObjectTypeComponent,
    NullTypeComponent,
    ArrayTypeComponent,
    MultiSchemaTypeComponent,
    HtmlWithPreviewTypeComponent,
    CodeTypeComponent,
    GenericProcessConfigurationComponent,
    ConfigAuditHistoryComponent,
    ConfigChangesDialogComponent,
    MeterOperatorDataComponent,
    ContactFormComponent,
    ConnectionObjectComponent,
    ConnectionObjectAddressComponent,
    OrderRequestsPreviewComponent,
    CreateErpOrderComponent,
    ErpOrderListComponent,
    ContactDetailsFormpartComponent,
    ContactAddressFormpartComponent,
    ErpOrderListComponent,
    ErrorComponent,
    IconCellRendererComponent,
    ErrorComponent,
    ErpOrderListComponent,
    ManageNextActionsComponent,
    EditActionModalComponent,
    ShowNextActionInfoComponent,
    NextActionCellRendererComponent,
    IconCellRendererComponent,
    HintCardComponent,
    ExtendedListFilterComponent,
    FilterInfoModalComponent,
    CommissioningRequestsPreviewComponent,
    SapConnectionObjectSelectorComponent,
    GenericSelectionModalComponent,
    ExternalPrivacyFormFieldComponent,
    ShowActivitiesProxyComponent,
    CalculationDetailComponent,
    QuillFormInputComponent,
    AdaptionSuppressAutocompleteDirective,
    PanelWrapperComponent,
    IsPersonPipe,
    SalutationTitlePipe,
    UserDecisionRadioButtonsComponent,
    TenantConfigProxyComponent,
    TenantConfigPipe,
    FeedbackCardComponent,
    TicketCellRendererComponent,
    TicketSystemProxyComponent,
    ZendeskTicketDetails,
    ZendeskTicketChat,
    BusinessPartnerFormpartComponent,
    ComparisonTableComponent,
    EditPersonalizationModalComponent,
    StringCheckboxComponent,
    EntityListInfoModalComponent,
    EntityDetailLayoutV2Component
  ],
  exports: [
    ErrorComponent,
    LoadingOverlayComponent,
    LoaderComponent,
    ContentSlideOverComponent,
    AreaIconPipe,
    AreaTextPipe,
    AreaTypePipe,
    HasRole,
    GpNamePipe,
    ActivityTypePipe,
    OfferStatePipe,
    DisplayNamePipe,
    OrderStatePipe,
    DocumentTypePipe,
    GermanCurrencyPipe,
    BooleanReadablePipe,
    TiefbauPipe,
    GisObjectLinksPipe,
    EtrsToWsgPipe,
    OpenActivitiesPipe,
    ConversationStatePipe,
    FileUploadComponent,
    EditContactDataComponent,
    GpSelectComponent,
    UserSelectComponent,
    ArchiveDocumentModalComponent,
    DocumentsComponent,
    CheckBooleanFieldsPipe,
    CompareFieldValuePipe,
    OrderByDatePipe,
    ProgressBarComponent,
    StatusProgressPipe,
    StatusPassCssPipe,
    PassStatusDisplayPipe,
    PassExpiredPipe,
    FilterExpirePassPipe,
    ShowHeaderTmDocumentPipe,
    TextHeaderTmDocumentPipe,
    FilterValidPassPipe,
    HideCustomFieldsDirective,
    ColumnEditorPageableComponent,
    LastActivityStatePipe,
    ContactNamePipe,
    UiShowCustomFieldsPipe,
    LinkedCommissioningPipe,
    LastActivityStatePipe,
    ContactNamePipe,
    SapCSOrderLinkPipe,
    FelixProjectLinkPipe,
    UiAdaptionValuePipe,
    UiAdaptionVisiblePipe,
    UiAdaptionVisibleAsyncPipe,
    UiCheckIfValuesPipe,
    PassTypePipe,
    ActivityDetailComponent,
    ToolTipDirective,
    GetGisDataComponent,
    ConfirmAndCreateActivityComponent,
    VeniosSimulationDeeplinkPipe,
    DocumentsListComponent,
    FormFocusableDirective,
    FocusEndOfInputDirective,
    CustomFormDirective,
    ShowErrorsComponent,
    ActionToExecuteType,
    SupplyAppointmentPartDayPipe,
    SheetUploadComponent,
    SafeHtmlPipe,
    RemoveHtmlTagsPipe,
    ImageUploadComponent,
    TermsConditionsComponent,
    PrivacyPolicyComponent,
    HeaderTitleComponent,
    DefaultCardComponent,
    QuestionTypePipe,
    DisplayAndSelectOptionComponent,
    SelectOptionModalComponent,
    FormRowComponent,
    CustomButtonComponent,
    UploadDocumentsComponent,
    ChronoUnitPipe,
    CodeListValuesComponent,
    CodeListValuesListComponent,
    ShowListValuesComponent,
    ScrollSpyMenuComponent,
    DataRangeComponent,
    RequestStatusPipe,
    StatusDisplayNamePipe,
    GetIbanComponent,
    ValueWithLabelComponent,
    DisplayConceptComponent,
    ActivityIconPipe,
    ActivityDescriptionPipe,
    ActivityInformationPipe,
    UserActivityPipe,
    StatusEntityAuditActivityPipe,
    ThankYouComponent,
    FormConfirmationComponent,
    ShowActivitiesComponent,
    TooltipIconComponent,
    StatusLabelComponent,
    DuplicateCheckCoreDebitorComponent,
    DuplicateCheckModalComponent,
    CreateErpBusinessPartnerModalComponent,
    ErrorPageComponent,
    RobustDatePipe,
    JaNeinPipe,
    RequestApprovalModalComponent,
    FieldSelectMultipleComponent,
    DragDropTodoListComponent,
    CustomNotificationComponent,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    FlexModule,
    AppMaterialModule,
    MailConfirmationComponent,
    ChangePasswordComponent,
    LoginDialogComponent,
    EditPersonalDataModalComponent,
    ShowLastActivityComponent,
    ShowHeaderDataComponent,
    ShowCreateUpdateDataComponent,
    ShowCreateUpdateConnectionObjectContactDataComponent,
    DocumentsListComponent,
    ContactFormComponent,
    ManageDocumentListComponent,
    EditDocumentModalComponent,
    RequestEntityDetailPageComponent,
    EntityListPageComponent,
    CustomFilterMenuComponent,
    ActionsCellRendererComponent,
    GenericProcessConfigurationComponent,
    ConfigAuditHistoryComponent,
    ConfigChangesDialogComponent,
    MeterOperatorDataComponent,
    ConnectionObjectComponent,
    ConnectionObjectAddressComponent,
    OrderRequestsPreviewComponent,
    ErpOrderListComponent,
    TenantlessEmailPipe,
    CodeListValuePipe,
    IsControlRequiredPipe,
    IsPersonPipe,
    SalutationTitlePipe,
    ContactAddressFormpartComponent,
    DynamicActionButtonRowComponent,
    EntityListPageColumnDefinitionsPipe,
    EntityListPageExportPipe,
    ShowNextActionInfoComponent,
    NextActionCellRendererComponent,
    MatBadgeModule,
    HintCardComponent,
    ExtendedListFilterComponent,
    CommissioningRequestsPreviewComponent,
    SapConnectionObjectSelectorComponent,
    GenericSelectionModalComponent,
    ExternalPrivacyFormFieldComponent,
    ShowActivitiesProxyComponent,
    CalculationDetailComponent,
    QuillFormInputComponent,
    AdaptionSuppressAutocompleteDirective,
    PanelWrapperComponent,
    UserDecisionRadioButtonsComponent,
    SafeUrlPipe,
    TenantConfigProxyComponent,
    TenantConfigPipe,
    FeedbackCardComponent,
    TicketSystemProxyComponent,
    ZendeskTicketDetails,
    ZendeskTicketChat,
    BusinessPartnerFormpartComponent,
    ComparisonTableComponent,
    EditPersonalizationModalComponent,
    StringCheckboxComponent,
    EntityListInfoModalComponent,
    EntityDetailLayoutV2Component
  ],
  providers: [
    ListService,
    CommissioningRequestListV2Service,
    GridRegistrationService,
    StatusProgressPipe,
    AreaTypePipe,
    RequestStatusPipe,
    PassStatusDisplayPipe,
    StatusPassCssPipe,
    ActionTypePipe,
    PowerMeterTypeDisplayNamePipe,
    HasInvalidExistingDevicesPipe,
    HasRole,
    EntityListPageColumnDefinitionsPipe,
    EntityListPageExportPipe,
    TenantlessEmailPipe,
    OfferStatePipe,
    RobustDatePipe,
    OrderStatePipe,
    BooleanReadablePipe,
    TiefbauPipe,
    OpenActivitiesPipe,
    ContactNamePipe,
    AreaTextPipe,
    CodeListValuePipe,
    IsControlRequiredPipe,
    StatusDisplayNamePipe,
    UiAdaptionVisibleAsyncPipe,
    UiAdaptionVisiblePipe,
    IsPersonPipe,
    SalutationTitlePipe,
    TenantConfigPipe
  ]
})
export class SharedModule {}
